module.exports = __webpack_public_path__ + "static/media/fleet-certified-icon-gold.74f5d3ef.svg";